import { Component, ViewChild } from '@angular/core';
import { PaginatorFetcher, PaginatorFilters, TableComponent, TableConfig } from '@michelin/theme';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PAGINATION_SIZES } from 'src/app/shared/utils/constants';
import { StockDto } from 'src/app/shared/models/stock/stock-dto';
import { of } from 'rxjs';
import { StockService } from 'src/app/shared/services/stock/stock.service';

@Component({
    selector: 'app-list-michelin-stock',
    templateUrl: './list-michelin-stock.component.html',
    standalone: false
})
export class ListMichelinStockComponent {
  tableConfig: TableConfig<StockDto> = {
    paginator: {
      pageSize: 10,
      position: 'bottom',
      pageSizeOptions: PAGINATION_SIZES
    },
    columns: {
      cai: { header: 'CAI', sortable: true, cell: (item) => item.cai },
      itemDescription: { header: 'Descrição', sortable: true, cell: (item) => item.itemDescription },
      stockQuantity: { header: 'Quantidade', sortable: true, cell: (item) => item.stockQuantity.toString() }
    }
  };

  filterForm: FormGroup = this.formBuilder.group({
    cai: [''],
    itemDescription: ['']
  });

  fetcher: PaginatorFetcher<StockDto> = (filters: PaginatorFilters) => this.stockService.search(filters);

  @ViewChild(TableComponent, { static: true }) table: TableComponent<StockDto>;

  constructor(private readonly formBuilder: FormBuilder, private readonly router: Router, private readonly stockService: StockService) {}

  get filterValues(): any {
    return this.filterForm.value;
  }

  applyFilter() {
    this.table.patchExtraFilters(this.filterValues);
  }

  resetFilter() {
    this.filterForm.reset();
    this.table.patchExtraFilters(this.filterValues);
  }
}
